import styled from '@emotion/styled';
import { Autocomplete, Box, Grid, Modal, Typography, TextField, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { Close } from '@mui/icons-material';
import { DropoutConst, dropoutReasons } from '../../../utils/dropoutAndSuspensionReasons';
import { LoadingButton } from '../../LoadingButton/LoadingButton';
import { dropoutClient } from '../../../services/programTrackClientMap.service';
import { ClientMapStatus } from '../../../utils/clientMapStatus';

const ModalWrapper = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const localStyle = {
  centeredStyle: {
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'auto',
    borderRadius: '14px',
    width: '600px',
    '@media (max-width: 480px)': {
      padding: '20px',
      margin: '10px',
    },
  },
  titleGrid: {
    direction: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  fieldArray: {
    position: 'relative',
    top: '20px',
    left: '17px',
    width: '515px',
  },
  loadingButtonGrid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 5,
  },
};

interface IDropoutReasonModal {
  open: boolean;
  onClose: Function;
  onSubmit: Function;
  clientList: any[];
  programTrackId: string;
  milestoneStep: string;
}

const DropoutReasonModal = (props: IDropoutReasonModal) => {
  const { open, onClose, clientList, programTrackId, milestoneStep, onSubmit } = props;
  const [selectedReason, setSelectedReason] = useState<any>();
  const [otherReason, setOtherReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleReasonChange = (event: any, newValue: any) => {
    setSelectedReason(newValue);
  };

  const handleClose = () => {
    onClose();
    setSelectedReason(null);
    setOtherReason('');
  };

  const handleSubmit = async () => {
    setLoading(true);
    const notePayload: any = {
      clientIds: clientList,
    };

    if (otherReason) {
      notePayload.description = otherReason;
    } else {
      notePayload.description = selectedReason.value;
    }

    const clientIds = clientList;
    await dropoutClient(
      clientIds,
      ClientMapStatus.DROP_OUT,
      milestoneStep,
      programTrackId,
      selectedReason.id,
      notePayload
    );
    handleClose();
    onSubmit();
    setLoading(false);
  };

  const checkDisable = () => {
    if (selectedReason) {
      if (selectedReason.id === DropoutConst.OTHER_OPTION_ID) {
        if (otherReason) {
          return false;
        } else {
          return true;
        }
      } else if (selectedReason.id !== DropoutConst.OTHER_OPTION_ID) {
        return false;
      }
    } else {
      return true;
    }
  };

  return (
    <ModalWrapper open={open} onClose={() => handleClose()}>
      <Box sx={localStyle.centeredStyle}>
        <Grid container sx={localStyle.titleGrid}>
          <Grid item>
            <Typography variant='h6'>Dropout Reason</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={() => handleClose()}>
              <Close />
            </IconButton>
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={localStyle.fieldArray}>
          <Grid item xs={12}>
            <Autocomplete
              value={selectedReason}
              onChange={handleReasonChange}
              options={dropoutReasons}
              getOptionLabel={(option) => option.value}
              renderInput={(params) => <TextField {...params} label='Select Reason' />}
            />
          </Grid>
          {selectedReason && selectedReason.id === DropoutConst.OTHER_OPTION_ID ? (
            <Grid item xs={12}>
              <TextField
                label='Other Reason'
                fullWidth
                multiline
                rows={3}
                variant='outlined'
                value={otherReason}
                onChange={(e) => setOtherReason(e.target.value)}
              />
            </Grid>
          ) : null}
        </Grid>
        <Grid item xs={12} lg={12} sx={localStyle.loadingButtonGrid}>
          <LoadingButton
            onClick={() => handleSubmit()}
            label={'Submit'}
            styles={{ width: '250px' }}
            loading={loading}
            disabled={loading || checkDisable()}
            size='large'
            type='submit'
            variant='contained'
          />
        </Grid>
      </Box>
    </ModalWrapper>
  );
};

export default DropoutReasonModal;
